import { render, staticRenderFns } from "./Repasses.vue?vue&type=template&id=362e2984&"
import script from "./Repasses.vue?vue&type=script&lang=js&"
export * from "./Repasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports